import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "t2-main" }
const _hoisted_2 = { class: "t2-content" }
const _hoisted_3 = {
  key: 0,
  class: "container mar_b"
}
const _hoisted_4 = { class: "t6_title_h1" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  class: "t6_table_b",
  style: {"margin-bottom":"48px"}
}
const _hoisted_7 = {
  class: "t6_table_b",
  style: {"margin-bottom":"48px"}
}
const _hoisted_8 = { class: "input_td" }
const _hoisted_9 = { class: "input_td" }
const _hoisted_10 = {
  class: "next_btn",
  style: {}
}
const _hoisted_11 = {
  key: 1,
  class: "step2"
}
const _hoisted_12 = { class: "line3" }

import { useRoute, useRouter } from 'vue-router';
    import {getBookableDateByDept, getAppointmentSummary,appointment} from '@/config/request';
    import { reactive, ref } from 'vue';
    import store from "@/store";
    import {ElMessage} from "element-plus";
import { rmSync } from 'fs';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'reservation-detail',
  setup(__props) {

    const route = useRoute()
    //部门编码
    let deptCode = route.query.dept_code
    //排队队列
    let name = route.query.name
    //队列编码
    let code = route.query.code
    //等候人数
    let waitingCount = route.query.waiting_count
    //平均等待时间
    let waitTimeoutMinute = route.query.wait_timeout_minute
    //平均办理时间
    let averageServiceMinute = route.query.average_service_minute
    // 预约日期,时间
    let reservationData = reactive({
      date:"",
      timeId:""
    });
    let showStep2 = ref(false)
    let loading = ref(false)
    let data = reactive({
        userInfo:{} as any
    })
    const router = useRouter()

    const init = async() => {
      //1、初始化预约人信息
      // data.userInfo = store.state.userInfomation
      data.userInfo.userName='田庆丰'
      data.userInfo.userMobile='18338402060'
      data.userInfo.certNo='410224199609213217'
      //2、初始化预约窗口信息
        let param = {
          deptCode:deptCode,
        }
        const res = await getBookableDateByDept(param) as any
        data.userInfo.attachDateList = [];
        if(res.success){
          data.userInfo.attachDateList = res.result.attachObjectEx
        }
      loading.value = true
    }

    init()

    const getTime = async() => {
      let param = {
        deptCode:"M001",
        appointDateTime:reservationData.date,
        groupCode : code,
      }
      console.log('param',param);

      const res = await getAppointmentSummary(param) as any
      data.userInfo.attachTimeList = [];
      reservationData.timeId='';
      if(res.success){
        let timePart = res.result.attachObjectEx
        const list = [];
        console.log(timePart,"timePart")
        for(let i = 0; i < timePart.length; i++){
          let obj = {
            id:'',
            datetime:'',
            group_code:'',
            schedule_code:'',
            begin_time:'',
          };
          let timePart1 = formatTime2(timePart[i].begin_datetime);
          let timePart2 = formatTime2(timePart[i].end_datetime);
          obj.datetime = timePart1+'-'+timePart2;
          obj.group_code = timePart[i].group_code;
          obj.schedule_code = timePart[i].schedule_code;
          obj.begin_time = timePart[i].begin_time;
          obj.id = timePart[i].id;
          list.push(obj);
        }
        data.userInfo.attachTimeList = list
      }
    }
    const formatTime2=(timeStr)=>{   //  返回 时
      let nowTime = new Date(timeStr);
      let time = nowTime.getHours() + ':00';
      return time;
    }
    let resultData =  reactive({
      time: '',
      code: '',
    })
    //提交预约
    const submitAppointment = async() => {
      if(!reservationData.date){
        ElMessage.error('预约日期不能为空！');
        return;
      }
      console.log(reservationData.timeId,"reservationData.time")
      if(!reservationData.timeId){
        ElMessage.error('预约时间不能为空！');
        return;
      }

      let timeData = data.userInfo.attachTimeList.filter((item)=>{
        return item.id ==reservationData.timeId;
      })
      let param = {
        name: data.userInfo.userName,
        mobile: data.userInfo.userMobile,
        code: data.userInfo.certNo,
        appointDateTime: reservationData.date+' '+timeData[0].begin_time, //2023-08-02 10:00
        appointTime:timeData[0].datetime,
        appointDate:reservationData.date,
        sequence:0,
        priorityCode:"C",
        groupCode: timeData[0].group_code,  //  固定写死
        serviceEmpCode:"",
        source:""
      }
      const res = await appointment(param) as any

      if(res.result.code === 0){
        ElMessage.success('预约成功')
        resultData.code = res.result.attachObjectEx.full_sequence

        let res2 = data.userInfo.attachTimeList.filter((item:any)=>{
          return item.id ==reservationData.timeId;
        })
        resultData.time = res2[0].datetime
        showStep2.value = true
      }else{
        ElMessage.error(res.result.description)
      }

      res.result.attachObjectEx
    }
  
return (_ctx: any,_cache: any) => {
  const _component_Top = _resolveComponent("Top")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_Bottom = _resolveComponent("Bottom")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Top, { fixedNobanner: true }),
    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "no_banner" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
        (_unref(loading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _cache[20] || (_cache[20] = _createElementVNode("div", { class: "t6_breadCream" }, [
                _createElementVNode("span", null, "首页"),
                _createTextVNode(),
                _createElementVNode("i", null, ">"),
                _createTextVNode(),
                _createElementVNode("span", null, "网上办事"),
                _createTextVNode(),
                _createElementVNode("i", null, ">"),
                _createElementVNode("span", null, "在线预约")
              ], -1)),
              _createElementVNode("div", _hoisted_4, [
                _createTextVNode(_toDisplayString(_unref(name)) + " ", 1),
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "t6_search" }, null, -1))
              ]),
              (!_unref(showStep2))
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "t6_title_h2" }, "窗口信息", -1)),
                    _createElementVNode("table", _hoisted_6, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _cache[4] || (_cache[4] = _createElementVNode("th", { width: "180" }, "窗口名称", -1)),
                          _createElementVNode("td", null, _toDisplayString(_unref(name)), 1),
                          _cache[5] || (_cache[5] = _createElementVNode("th", { width: "180" }, "等候人数", -1)),
                          _createElementVNode("td", null, _toDisplayString(_unref(waitingCount)), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[6] || (_cache[6] = _createElementVNode("th", null, "平均等待时间（分钟）", -1)),
                          _createElementVNode("td", null, _toDisplayString(_unref(waitTimeoutMinute)), 1),
                          _cache[7] || (_cache[7] = _createElementVNode("th", null, "平均办理时间（分钟）", -1)),
                          _createElementVNode("td", null, _toDisplayString(_unref(averageServiceMinute)), 1)
                        ])
                      ])
                    ]),
                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "t6_title_h2" }, "预约信息", -1)),
                    _createElementVNode("table", _hoisted_7, [
                      _createElementVNode("tbody", null, [
                        _createElementVNode("tr", null, [
                          _cache[8] || (_cache[8] = _createElementVNode("th", { width: "180" }, "姓名", -1)),
                          _createElementVNode("td", null, _toDisplayString(_unref(data).userInfo.userName), 1),
                          _cache[9] || (_cache[9] = _createElementVNode("th", { width: "180" }, "手机号", -1)),
                          _createElementVNode("td", null, _toDisplayString(_unref(data).userInfo.userMobile), 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[10] || (_cache[10] = _createElementVNode("th", null, "身份证号", -1)),
                          _createElementVNode("td", null, _toDisplayString(_unref(data).userInfo.certNo), 1),
                          _cache[11] || (_cache[11] = _createElementVNode("th", null, "预约日期", -1)),
                          _createElementVNode("td", _hoisted_8, [
                            _createVNode(_component_el_select, {
                              modelValue: _unref(reservationData).date,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(reservationData).date) = $event)),
                              onChange: _cache[1] || (_cache[1] = ($event: any) => (getTime())),
                              style: {"width":"100%","height":"100%"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).userInfo.attachDateList, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    value: item,
                                    key: item,
                                    label: item
                                  }, null, 8, ["value", "label"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ]),
                        _createElementVNode("tr", null, [
                          _cache[12] || (_cache[12] = _createElementVNode("th", null, "预约时间", -1)),
                          _createElementVNode("td", _hoisted_9, [
                            _createVNode(_component_el_select, {
                              modelValue: _unref(reservationData).timeId,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(reservationData).timeId) = $event)),
                              style: {"width":"100%","height":"100%"}
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).userInfo.attachTimeList, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    value: item.id,
                                    key: item.id,
                                    label: item.datetime
                                  }, null, 8, ["value", "label"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createVNode(_component_el_button, {
                        onClick: submitAppointment,
                        size: "large",
                        color: "#2185f2",
                        style: {"color":"#fff"}
                      }, {
                        default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                          _createTextVNode("提交预约", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "line1" }, "预约成功", -1)),
                    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "line2" }, "请携带所需证件材料，按照预约时间前往预约网点办理！", -1)),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", null, [
                        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "span1" }, "预约时间：", -1)),
                        _createElementVNode("span", null, _toDisplayString(_unref(reservationData).date) + " " + _toDisplayString(_unref(resultData).time), 1)
                      ]),
                      _createElementVNode("div", null, [
                        _cache[17] || (_cache[17] = _createElementVNode("span", { class: "span1" }, "预约号码：", -1)),
                        _createElementVNode("span", null, _toDisplayString(_unref(resultData).code), 1)
                      ])
                    ])
                  ]))
            ]))
          : _createCommentVNode("", true)
      ])), [
        [_directive_loading, !_unref(loading)]
      ])
    ]),
    _createVNode(_component_Bottom)
  ], 64))
}
}

})